import React from 'react'
import classNames from 'classnames'

/** Bootstrap justify-content suffix tokens */
type JustifyContent = 'start' | 'center' | 'end' | 'between' | 'around'

/** Bootstrap align-items suffix tokens */
type AlignItems = 'start' | 'center' | 'end'

interface FlexProps extends React.HTMLAttributes<HTMLElement> {
    /** Bootstrap `justify-content-*` utility suffix */
    justify?: JustifyContent
    /** Bootstrap `align-items-*` utility suffix */
    align?: AlignItems
    /** Render `d-inline-flex` instead of `d-flex` */
    inline?: boolean
    /** Add `flex-column` class */
    column?: boolean
    /** Add `flex-wrap` class */
    wrap?: boolean
    /** Extra CSS classes */
    className?: string
    /** HTML tag or component to render as the flex container */
    tag?: React.ElementType
    children: React.ReactNode
}

/**
 * Convenience wrapper that maps simple boolean / string props to Bootstrap
 * flexbox utility classes while forwarding all other HTML attributes.
 */
const Flex = ({
    justify,
    align,
    inline = false,
    column = false,
    wrap = false,
    className,
    tag: Tag = 'div',
    children,
    ...rest
}: FlexProps) => (
    <Tag
        className={classNames(
            {
                'd-flex': !inline,
                'd-inline-flex': inline,
                [`justify-content-${justify}`]: justify,
                [`align-items-${align}`]: align,
                'flex-column': column,
                'flex-wrap': wrap,
            },
            className,
        )}
        {...rest}
    >
        {children}
    </Tag>
)

export default Flex
